<template>
  <div class="page-wheels">
    <!-- Project -->
    <div class="close-button-wrapper flex-center" :class="{'scale-in-center-2s': useComponentButton === 'load'}" v-if="useComponentButton === 'load' || useComponentButton === 'edit'">
    <!-- <div class="close-button-wrapper flex-center scale-in-center-2s" v-if="useComponentButton && view === 'project' || (getShowProjectModal && getWheelVisible && view !== 'project')"> -->
        <button @click="$emit('saveProject')" class="button close-button">
            <span v-if="!getProject.name">{{$t('modal-project.modalButtonlabelNew')}}</span>
            <span v-else>{{$t('modal-project.modalButtonlabelExisting')}}</span>
        </button>
    </div>

    <!-- Goals -->
    <div @click="$emit('goToTargets')" :class="[getSelectedGoals.length > 0 ? 'scale-in-center' : 'scale-out-center']" v-if="useComponentButton === 'true' && view === 'goals' && getSelectedGoals.length > 0" class="continue-button-wrapper flex-center">
        <button class="continue-button">
            <span>{{$t('goals.buttonlabelContinue')}}</span>
        </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sdgWheels from './sdg-wheels'

export default {
  name: 'sdg-wheel',
  props: {
    buttonRadius: {
      type: Number,
      default: 100
    },
    buttonText: {
      type: String,
      default: 'Start'
    },
    useComponentButton: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: 'standard'
    },
    showGoalsImmediately: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    view: {
      type: String
    }
  },
  data () {
    return {
      jsWheel: null,
      iconsPath: []
    }
  },
  computed: {
    ...mapGetters({
      getSelectedScenario: 'getSelectedScenario',
      getProject: 'getProject',
      getLanguage: 'getLanguage',
      getWheelVisible: 'getWheelVisible',
      getUnSelectedGoals: 'getUnSelectedGoals',
      getSelectedGoals: 'getSelectedGoals',
      getShowProjectModal: 'getShowProjectModal',
      getIconsPath: 'getIconsPath',
      getIconsSelected: 'getIconsSelected',
      getEnableBookPageTurn: 'getEnableBookPageTurn'
    })
  },
  methods: {
    ...mapActions({
      setIconsPath: 'setIconsPath',
      setEnableBookPageTurn: 'setEnableBookPageTurn'
    }),
    createSvg () {
      let options = {
        mode: this.mode,
        showGoalsImmediately: this.showGoalsImmediately,
        name: this.name
      }
      if (this.mode === 'select') {
        options.showIconsImmediately = false
        options.icons = this.getIconsPath

        this.jsWheel = new sdgWheels.Nav(options)

        this.jsWheel.on('select', (goal) => {
          this.$emit('goalClicked', goal.id)
        })

        this.jsWheel.on('unselect', (goal) => {
          this.$emit('goalClicked', goal.id)
        })

        this.$el.appendChild(this.jsWheel.getSvg())
      } else if (this.mode === 'target') {
        options.showIconsImmediately = true
        options.icons = this.getIconsPath

        this.jsWheel = new sdgWheels.Nav(options)

        this.jsWheel.on('select', (goal) => {
          this.$emit('goalClicked', goal.id)
        })
        this.$el.appendChild(this.jsWheel.getSvg())
      } else {
        this.jsWheel = new sdgWheels.Nav(options)
        this.$el.appendChild(this.jsWheel.getSvg())

        if (!options.showGoalsImmediately) {
          setTimeout(() => {
            this.jsWheel.reveal()
          }, 2000)
        }
      }
    }
  },
  watch: {
    getLanguage (val) {
      if (this.mode !== 'standard') {
        this.setIconsPath()
        this.jsWheel.setIcons(this.getIconsPath)
      }
    },
    getIconsSelected (val, oldVal) {
      if (val !== oldVal) {
        this.$nextTick(() => {
          this.createSvg()
        })
      }
    },
    getWheelVisible (val, oldVal) {
      if (val !== oldVal && this.view === this.jsWheel.name) {
        if (this.view === 'goals' && val) {
          this.getSelectedScenario.goals.forEach(selectedGoal => {
            this.jsWheel.selectGoal(selectedGoal.code)
          })

          this.jsWheel.revealIcons()

          if (!this.getEnableBookPageTurn) {
            this.setEnableBookPageTurn(true)
          }
        } else if (this.view === 'targets' && val) {
          for (let i = 1; i <= 17; i++) {
            if (this.getUnSelectedGoals.indexOf(i) === -1) {
              this.jsWheel.enableGoal(i, false)
            } else {
              this.jsWheel.disableGoal(i, false)
            }
          }
          this.jsWheel.selectGoal(this.getSelectedGoals[0])
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .nsdg-nav-wheel {
    height: 100%;
  }
</style>
